module.exports = __webpack_public_path__ + "img/a2.90af09f3.png";